import React, { Component } from 'react';
import Cards from '../widgets/cards/cards';

export default class RobotList extends Component {
  render() {
    return (
      <div>
        <Cards user={this.props.user}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/robots_list.js